import api from '../api/axios';

const getHistory = (proposalId, limit = 50, offset = 0) => {
  return api.get(`/proposal/${proposalId}/history?limit=${limit}&offset=${offset}`);
};

const getHistoryEntry = (proposalId, historyId) => {
  return api.get(`/proposal/${proposalId}/history/${historyId}`);
};

const proposalHistoryServices = {
  getHistory,
  getHistoryEntry,
};

export default proposalHistoryServices;

